import { useCallback, useEffect, useRef, useState } from "react";
import CopyToClipboard from "copy-to-clipboard";
import styled from "styled-components";

const StyledClipboardCopier = styled.div`
  position: relative;
  display: inline-flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`;

const StyledCopied = styled.div`
  position: absolute;
  z-index: 20;
  bottom: calc(100% + 10px);
  left: 50%;
  display: inline-flex;
  align-items: center;
  padding: 7px 11px;
  border: 1px solid rgba(150, 185, 75, 0.4);
  border-radius: 999px;
  background: #f0ece5;
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.34);
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  visibility: ${({ $visible }) => ($visible ? "visible" : "hidden")};
  transform: translate(-50%, ${({ $visible }) => ($visible ? "-3px" : "3px")});
  pointer-events: none;
  transition: opacity 160ms ease, transform 160ms ease, visibility 160ms ease;
  white-space: nowrap;

  &::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    width: 8px;
    height: 8px;
    background: #f0ece5;
    transform: translate(-50%, -50%) rotate(45deg);
  }
`;

const StyledCopiedText = styled.span`
  font-family: Roboto-Regular;
  color: #08111b;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.04em;
  line-height: 1;
  text-transform: uppercase;
`;

export const ClipboardCopier = ({ children, text }) => {
  const [isTextCopied, setIsTextCopied] = useState(false);
  const timeoutIdRef = useRef(null);

  useEffect(() => () => clearTimeout(timeoutIdRef.current), []);

  const showTextCopied = useCallback(() => {
    clearTimeout(timeoutIdRef.current);
    setIsTextCopied(true);

    timeoutIdRef.current = setTimeout(() => {
      setIsTextCopied(false);
    }, 2000);
  }, []);

  const copyToClipboard = useCallback(() => {
    CopyToClipboard(text);
    showTextCopied();
  }, [showTextCopied, text]);

  return (
    <StyledClipboardCopier onClick={copyToClipboard}>
      {children}
      <StyledCopied
        $visible={isTextCopied}
        role="status"
        aria-live="polite"
        aria-atomic="true"
        aria-hidden={!isTextCopied}
      >
        <StyledCopiedText>Copied</StyledCopiedText>
      </StyledCopied>
    </StyledClipboardCopier>
  );
};
